import { useState, FormEvent } from 'react';
import { submitContact } from '../services/forms';
import { useLanguage } from '../i18n/LanguageContext';

const MESSAGE_TYPES = ['Genel Bilgi', 'Operasyon', 'Teklif Talebi', 'Basın'];

export function ContactForm() {
  const { t } = useLanguage();
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    messageType: 'Genel Bilgi',
    subject: '',
    message: '',
  });

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await submitContact({
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim(),
        subject: (form.subject || form.messageType).trim(),
        message: form.message.trim(),
      });
      setStatus('success');
      setForm({
        firstName: '',
        lastName: '',
        email: '',
        messageType: 'Genel Bilgi',
        subject: '',
        message: '',
      });
    } catch (err) {
      setStatus('error');
      setError(err instanceof Error ? err.message : 'Mesaj gönderilemedi.');
    }
  }

  return (
    <form className="contact-showcase-form" onSubmit={handleSubmit}>
      {status === 'success' ? (
        <p className="form-note">
          {t('Mesajınız alındı. Ekibimiz en kısa sürede size dönüş yapacaktır.')}
        </p>
      ) : (
        <>
          {status === 'error' && <p className="form-error">{t(error)}</p>}
          <div className="contact-showcase-row two">
            <div>
              <label>{t('Ad')}</label>
              <input
                type="text"
                required
                placeholder={t('Ad')}
                value={form.firstName}
                onChange={(e) => setForm({ ...form, firstName: e.target.value })}
              />
            </div>
            <div>
              <label>{t('Soyad')}</label>
              <input
                type="text"
                required
                placeholder={t('Soyad')}
                value={form.lastName}
                onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              />
            </div>
          </div>
          <div className="contact-showcase-row">
            <div>
              <label>{t('E-posta')}</label>
              <input
                type="email"
                required
                placeholder={t('E-posta')}
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
          </div>
          <div className="contact-showcase-row">
            <div>
              <label>{t('Mesaj Türü')}</label>
              {/* deger Turkce kalir: talep e-postasi ve portal kayitlari tek dilde tutulur */}
              <select
                value={form.messageType}
                onChange={(e) => setForm({ ...form, messageType: e.target.value })}
              >
                {MESSAGE_TYPES.map((type) => (
                  <option key={type} value={type}>
                    {t(type)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="contact-showcase-row">
            <div>
              <label>{t('Konu Seçiniz')}</label>
              <input
                type="text"
                placeholder={t('Konu Seçiniz')}
                value={form.subject}
                onChange={(e) => setForm({ ...form, subject: e.target.value })}
              />
            </div>
          </div>
          <div className="contact-showcase-row">
            <div>
              <label>{t('Mesajınız...')}</label>
              <textarea
                placeholder={t('Mesajınız...')}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                required
              />
            </div>
          </div>
          <button className="contact-showcase-submit" type="submit" disabled={status === 'sending'}>
            {status === 'sending' ? t('Gönderiliyor...') : t('Gönder →')}
          </button>
        </>
      )}
    </form>
  );
}
